var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#00664F"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.304 10.134c-.01-.866-.634-1.527-1.643-1.527-1 0-1.661.661-1.661 1.527 0 .801.565 1.451 1.463 1.52l.18.007c1.027 0 1.67-.679 1.66-1.527m-.188 2.732H10.17v8.848h2.946zm4.562 1.258v-1.258H14.74v8.849h2.938v-4.938c0-.268.026-.527.098-.723.214-.527.696-1.071 1.509-1.071 1.062 0 1.491.812 1.491 2v4.732h2.938v-5.072c0-2.714-1.447-3.982-3.384-3.982-1.409 0-2.116.694-2.526 1.275z",
  clipRule: "evenodd"
})));
export default SvgLinkedin;